
function getOrderRefDisplay(orderCode: string, customerRef: string, cutomerName: string): string {
  const reference = customerRef || orderCode;
  return `${reference} | ${cutomerName}`
}

export const orderUtils = Object.freeze({
  getOrderRefDisplay
});